import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Search, MessageSquare, Star, Globe, ThumbsUp, Send, Layers } from "lucide-react";
import { FEATURED_PACKAGES } from "../data/constants";
import { PackageCard } from "../components/PackageCard";
import { SEO } from "../components/SEO";

const ServicesPage = () => {
  const navigate = useNavigate();
  return (
    <div className="pt-20" data-testid="services-page">
      <SEO
        title="Services"
        description="Comprehensive digital marketing solutions powered by AI — SEO, AI Receptionist, Reputation Management, Local Listings, Social Marketing, and Programmatic DSP."
        path="/services"
      />
      <section className="section-padding bg-gradient-to-br from-orange-light via-white to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="font-display text-4xl md:text-5xl font-bold text-gray-dark mb-4">Our Services</h1>
            <p className="text-gray-medium text-lg max-w-2xl mx-auto">
              Comprehensive digital marketing solutions powered by AI
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {FEATURED_PACKAGES.map((pkg) => (
              <PackageCard key={pkg.id} pkg={pkg} />
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {[
              { icon: Search, title: "SEO Optimization", desc: "Boost your search rankings with our proven SEO strategies" },
              { icon: MessageSquare, title: "AI Receptionist", desc: "24/7 AI-powered customer engagement across all channels" },
              { icon: Star, title: "Reputation Management", desc: "Build and maintain a stellar online reputation" },
              { icon: Globe, title: "Local Listings", desc: "Sync your business info across 60+ directories" },
              { icon: ThumbsUp, title: "Social Marketing", desc: "AI-generated content that drives engagement" },
              { icon: Send, title: "Email Campaigns", desc: "Automated email marketing that converts" }
            ].map((service) => (
              <div key={service.title} className="bg-white p-6 rounded-xl shadow-card card-hover">
                <service.icon className="text-orange-primary mb-4" size={40} />
                <h3 className="font-display font-bold text-lg text-gray-dark mb-2">{service.title}</h3>
                <p className="text-gray-medium text-sm">{service.desc}</p>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-br from-gray-dark to-gray-900 rounded-2xl p-8 text-white mb-12">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-xl bg-orange-primary/20 flex items-center justify-center">
                  <Layers className="text-orange-secondary" size={32} />
                </div>
                <div>
                  <h3 className="font-display font-bold text-xl">Programmatic DSP</h3>
                  <p className="text-gray-300">Self-Serve Paid Media — Launch programmatic campaigns with full control</p>
                </div>
              </div>
              <button onClick={() => navigate("/dsp")} className="btn-primary whitespace-nowrap">
                Explore DSP <ArrowRight size={18} className="inline ml-2" />
              </button>
            </div>
          </div>

          <div className="text-center">
            <button onClick={() => navigate("/store")} className="btn-primary text-lg" data-testid="services-browse-btn">
              Browse All Services in Store <ArrowRight size={20} className="inline ml-2" />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
